import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterBooleanSearchValueObject} from './FilterBooleanSearchValueObject.js'

export class FilterHasPhotoSearchValueObject extends ValueObject {
  #hasPhoto

  constructor({hasPhoto}) {
    super()
    this.#hasPhoto = hasPhoto
  }

  static create({hasPhoto}) {
    return new FilterHasPhotoSearchValueObject({hasPhoto: FilterBooleanSearchValueObject.create(hasPhoto)})
  }

  static createWithDefaultValue({config, hasPhoto}) {
    const {DEFAULT_HAS_PHOTO_SEARCH} = config.get('searchFilters')

    return new FilterHasPhotoSearchValueObject({
      hasPhoto: FilterBooleanSearchValueObject.create({boolean: hasPhoto ?? DEFAULT_HAS_PHOTO_SEARCH})
    })
  }

  static createQueryParams({config, hasPhoto}) {
    const {DEFAULT_HAS_PHOTO_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterHasPhotoSearchValueObject({
      hasPhoto: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.HAS_PHOTO],
        value: hasPhoto === DEFAULT_HAS_PHOTO_SEARCH ? null : hasPhoto
      })
    })
  }

  get isEmpty() {
    return this.#hasPhoto.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#hasPhoto.queryParam})
    }
  }

  get value() {
    return this.#hasPhoto.value
  }

  toJSON() {
    return {
      hasPhoto: this.#hasPhoto.toJSON()
    }
  }
}
